export type QcShift = 'A' | 'B' | 'C';

export function parseRoleIds(roles: string | undefined | null): string[] {
  if (!roles) return [];
  try {
    const parsed = JSON.parse(roles);
    return Array.isArray(parsed) ? parsed.map(String) : [String(parsed)];
  } catch {
    return [roles];
  }
}

/** Shift stamped on the signed-in QC account, or null for Admin and other roles. */
export function assignedQcShift(roles: string | undefined | null): QcShift | null {
  const ids = parseRoleIds(roles);
  if (ids.includes('qc_shift_a')) return 'A';
  if (ids.includes('qc_shift_b')) return 'B';
  if (ids.includes('qc_shift_c')) return 'C';
  return null;
}

/** Admin, CEO, and production manager may record or report any shift. */
export function canChooseQcShift(roles: string | undefined | null): boolean {
  const ids = parseRoleIds(roles);
  return ids.includes('admin') || ids.includes('ceo') || ids.includes('production_manager');
}

/** Shared recovery sheet: Admin and the three QC shifts. CEO is not included. */
export function canEditRecovery(roles: string[] | string | undefined | null): boolean {
  const ids = Array.isArray(roles) ? roles : parseRoleIds(roles);
  return ids.includes('admin') || ids.includes('qc_shift_a') || ids.includes('qc_shift_b') || ids.includes('qc_shift_c');
}
